const isBrowser = typeof document !== "undefined";

export { isBrowser as i };
//# sourceMappingURL=browser.js.map
